import type { TOC } from '@ember/component/template-only'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { PageHeaderReturnLink } from 'teacher-ui-client/components/page-header/return-link'
import { t } from 'ember-intl'
import RouteTemplate from 'ember-route-template'

export const ManageImportStudents: TOC<unknown> = <template>
  <PageHeader>
    <:title>
      <h1>
        {{t "manage.students.bulkActions.csv.title"}}
      </h1>
    </:title>
    <:left>
      <PageHeaderReturnLink @route="manage.students">
        {{t "manage.manageClasses.returnLink"}}
      </PageHeaderReturnLink>
    </:left>
  </PageHeader>
  {{outlet}}
</template>

export default RouteTemplate(ManageImportStudents)
